import { PropertyTypes } from '@aloft/toolkit-shared';

import { BreakdownColumn } from '../../types.ts';
import {
  GLA_BREAKDOWN_ALL_MANUFACTRUED_TEXT,
  GLA_BREAKDOWN_ALL_MANUFACTURED_COLUMNS,
  GLA_BREAKDOWN_ALL_MULTIFAMILY_COLUMNS,
  GLA_BREAKDOWN_ALL_MULTIFAMILY_TEXT,
  GLA_BREAKDOWN_MULTIPLE_TYPES_COLUMNS,
  GLA_BREAKDOWN_MULTIPLE_TYPES_TEXT,
  GLA_BREAKDOWN_SFR_COLUMNS,
  GLA_BREAKDOWN_SFR_ONLY_TEXT,
} from './consts.ts';

export const getAdjustmentBreakdownGlaProps = (
  propertyTypeSet: Set<PropertyTypes>,
): {
  title: string;
  columns: BreakdownColumn[];
  description: string;
} => {
  if (propertyTypeSet.size > 1) {
    return {
      title: 'GLA Adjustment',
      columns: GLA_BREAKDOWN_MULTIPLE_TYPES_COLUMNS,
      description: GLA_BREAKDOWN_MULTIPLE_TYPES_TEXT,
    };
  }
  if (propertyTypeSet.has('multiFamily')) {
    return {
      title: 'GBA Adjustment',
      columns: GLA_BREAKDOWN_ALL_MULTIFAMILY_COLUMNS,
      description: GLA_BREAKDOWN_ALL_MULTIFAMILY_TEXT,
    };
  }
  if (propertyTypeSet.has('manufacturedHome')) {
    return {
      title: 'GLA Adjustment (Main Dwelling)',
      columns: GLA_BREAKDOWN_ALL_MANUFACTURED_COLUMNS,
      description: GLA_BREAKDOWN_ALL_MANUFACTRUED_TEXT,
    };
  }
  if (propertyTypeSet.has('singleFamilyResidence')) {
    return {
      title: 'GLA Adjustment',
      columns: GLA_BREAKDOWN_SFR_COLUMNS,
      description: GLA_BREAKDOWN_SFR_ONLY_TEXT,
    };
  }

  return {
    title: 'GLA Adjustment',
    columns: GLA_BREAKDOWN_SFR_COLUMNS,
    description: GLA_BREAKDOWN_SFR_ONLY_TEXT,
  };
};
